import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {appConfig} from "config/defaultConfig";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {Drawer, DrawerBody, DrawerHeader} from "components/Drawer";
import DrawerTitle from "components/Drawer/components/DrawerTitle/DrawerTitle";
import EmptyContent from "components/EmptyContent";
import {getFormattedDate} from "utils/dateutils";
import {getShortId} from "utils/misc";
import css from "./LinkedIncidentsDrawer.module.scss";

const LinkedIncidentsDrawer = ({isOpen, onClose, linkedIncidents}) => {
  const {t} = useTranslation();
  const {INCIDENTS, INCIDENT_DETAIL} = appConfig.APP.ROUTES;

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <DrawerHeader hideDivider style={{padding: "16px 24px 12px"}}>
        <DrawerTitle
          style={{margin: "0"}}
          title={t("incidentDetail.detail.linkedIncidents", {
            count: linkedIncidents.length
          })}
        />
      </DrawerHeader>
      <DrawerBody>
        {linkedIncidents.length === 0 ? (
          <EmptyContent>
            {t("incidentDetail.detail.noLinkedIncidents")}
          </EmptyContent>
        ) : (
          <>
            {linkedIncidents.map((incident, index) => {
              const incidentId = getShortId(incident.id);
              const key = `incident-${incidentId}-${index}`;
              return (
                <div
                  className={css.incidentItem}
                  key={key}
                  data-testid={`incident-list-item-${index}`}>
                  <AButton
                    className={css.incidentTitle}
                    component={Link}
                    target="_blank"
                    to={`${INCIDENTS}/${incidentId}/${INCIDENT_DETAIL.OVERVIEW}`}
                    tertiary>
                    {incident.title}
                  </AButton>
                  <p className={css.linkedIncidentCreatedDate}>
                    {t("incidentDetail.detail.createdDate", {
                      createdDate: getFormattedDate(
                        incident.incident_time?.opened
                      )
                    })}
                  </p>
                </div>
              );
            })}
          </>
        )}
      </DrawerBody>
    </Drawer>
  );
};

LinkedIncidentsDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  linkedIncidents: PropTypes.array.isRequired
};

export default LinkedIncidentsDrawer;
